// eslint-disable-next-line filename-rules/not-match
import styled from '@emotion/styled';
import Link from 'src/components/Link/Link';
import RightArrowCircleIcon from 'src/assets/icons/RightArrowCircleIcon';
import { withConfig } from 'src/utils/withConfig';

export const HeaderWrapper = withConfig(theme => styled('header', { label: 'HeaderWrapper' })`
    align-items: center;
    background: ${theme.header.bgColor};
    display: flex;
    flex-direction: row;
    flex: 0 0 56px;
    height: 56px;
    position: relative;
    width: 100%;
`);

export const MenuItemsWrapper = styled('div', { label: 'MenuItemsWrapper' })`
    display: flex;
    justify-content: space-between;
    flex: 1 1 auto;
    align-items: center;
    height: 100%;
`;

interface ListElementPropsType {
    isActive: boolean;
    isDisabled?: boolean;
    dataTest?: string;
}

export const ListElement = withConfig(theme => styled(Link, { label: 'ListElement' })<ListElementPropsType>`
    font-family: var(--fontFamilyPrimary);
    border-radius: 4px;
    color: ${({ isActive }): string => isActive ? theme.header.txtColorTertiary : theme.header.txtColor};
    cursor: ${({ isDisabled }): string => isDisabled === true ? 'default' : 'pointer'};
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    height: 32px;
    line-height: 1.3334;
    margin-right: 12px;
    padding: 8px 16px;
    position: relative;
    text-decoration: none;
    transition: color .2s ease;
    white-space: nowrap;
    z-index: 0;
    &::before {
        background: ${({ isActive, isDisabled }): string => isActive ? theme.header.bgColorQuaternary : isDisabled === true ? '#fff' : 'none' };
        border-radius: 4px;
        border: 2px solid ${({ isActive }): string => isActive ? theme.header.borderColorSecondary : 'transparent' };
        bottom: 0;
        content: '';
        left: 0;
        opacity: ${({ isActive, isDisabled }): string => isActive ? '1' : isDisabled === true ? '0.6' : '0' };
        position: absolute;
        right: 0;
        top: 0;
        transition: opacity .2s ease, visibility .2s ease;
        visibility: ${({ isActive, isDisabled }): string => isActive ? 'visible' : isDisabled === true ? 'visible' : 'hidden' };
        z-index: -1;
    }
    &:hover {
        ${({ isActive, isDisabled }): string => isActive || isDisabled === true ? '' : `color: ${theme.header.txtColorSecondary}`};
        &::before {
            border-color: ${({ isActive, isDisabled }): string => isActive ? theme.header.bgColorQuaternary : isDisabled === true ? 'none' : theme.header.borderColor};
            opacity: ${({ isDisabled }): string => isDisabled === true ? '0.6' : '1'};
            visibility: visible;
        }
    }
    &:focus {
        outline-color: transparent;
    }
`);

export const ListElements = styled('nav', { label: 'ListElements' })`
    margin-left: 24px;
`;

export const MenuRightArea = styled('div', { label: 'MenuRightArea' })`
    display: flex;
    flex: 0 0 162px;
    justify-content: flex-end;
    height: 100%;
`;

interface LogoutPropsType {
    onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const Logout = styled('div', { label: 'Logout' })<LogoutPropsType>`
    display: flex;
    flex: 0 0 56px;
    margin: auto 0 auto 13px;
    justify-content: center;
    cursor: pointer;
    height: 100%;
`;

export const RightArrowCircleIconWrapper = withConfig(theme => styled(RightArrowCircleIcon, { label: 'RightArrowCircleIconWrapper' })`
    fill: ${theme.header.bgColorTertiary};
`);
